import { ReactElement, useContext } from "react";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { useLocation } from "react-router-dom";
import EDCIcon from "../assets/edc_logo.png";
import { useStyles } from "./MicrosoftSSO.styles";
import AuthButton from "./AuthButton";
import { EDC_SSO_REDIRECT_PATH } from "../constants";

interface Props {
  text: string;
  isEventHappeningNow?: boolean; // only when used in event landing
}

const EDCSSOButton = ({
  text,
  isEventHappeningNow,
}: Props): ReactElement | null => {
  const { track } = useContext(TRACKING_CONTEXT);
  const classes = useStyles();
  const location = useLocation();

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent immediate navigation

    if (isEventHappeningNow !== undefined) {
      await track(Events.LOGIN_CLICKED_EDC, {
        eventStatus: isEventHappeningNow ? "ongoing" : "upcoming",
      });
    }

    const currentPath = location.pathname + location.search;
    if (
      !currentPath.startsWith("/signin") &&
      !currentPath.startsWith("/signup")
    ) {
      localStorage.setItem(EDC_SSO_REDIRECT_PATH, currentPath);
    }

    window.location.href = process.env.REACT_APP_EDC_AUTHORIZE_URL || "";
  };

  return (
    <AuthButton
      onClick={handleClick}
      data-testid="edc-sso-button"
      startAdornment={<img src={EDCIcon} alt={text} className={classes.logo} />}
    >
      {text}
    </AuthButton>
  );
};

export default EDCSSOButton;
